export default "__VITE_ASSET__Cvi4Pf8X__"